@use "assets/styles/abstracts/variables" as v;

.mainViews {
    position: relative;
    background: v.$gradient-black;
    border: 2px solid v.$palette-gray-900;
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;

    @media (min-width: 768px) {
        padding: 32px;
    }
    
    @media (min-width: 1200px) {
        flex-direction: row;
        padding: 40px;
        max-width: 1170px;
        margin: 0 auto;
    }
}

.background {
    position: absolute;
    width: 200%;
    height: 180%;
    left: 50%;
    transform: translateX(-50%);
    top: -412px;
    z-index: -1;
}